import BezierEasing from 'bezier-easing'

export const CubicBezier = BezierEasing(0.6,0.6,0,1);
export const CSSTransitionTime = 450